export const environment = {
  production: false,
  baseUrl: 'https://demo.api.mytinyerp.com/api/',
  ipUrl:'https://api.ipify.org/?format=json',
};